import { getIcon, isParentActive } from './Helpers.tsx';
import { NavLink } from '@mantine/core';
import { NavLinkWithoutChildren } from './NavLinkWithoutChildren.tsx';
import { MenuItemWithChildren } from './Menu.tsx';
import { useMenuStyles } from './UseMenuStyles.tsx';

export function NavLinkWithChildren({
    collapsed,
    menuItem,
}: {
    collapsed?: boolean;
    menuItem: MenuItemWithChildren;
}) {
    const { classes } = useMenuStyles();
    const label = collapsed ? '' : menuItem.label;
    const children = menuItem.children ?? [];
    if (children.length === 0) return null;
    const paths = children.filter((c) => c.url).map((c) => c.url) as string[];
    const active = isParentActive(paths);
    return (
        <NavLink
            icon={getIcon(menuItem.icon)}
            title={menuItem.label}
            label={label}
            key={menuItem.label}
            className={active ? 'active' : undefined}
            classNames={classes}
            defaultOpened={active}
        >
            {children?.map((child) => {
                return (
                    <NavLinkWithoutChildren
                        key={`${menuItem.label}=>${child.label}`}
                        menuItem={child}
                        collapsed={collapsed}
                    />
                );
            })}
        </NavLink>
    );
}
